import es from 'element-ui/lib/locale/lang/es';

// 西班牙语(墨西哥)
export default {
  ...es,
  layout: {
    title: 'Iniciar sesión con el ID de Uniportal',
    tip: 'Los números de teléfono móvil no registrados se registrarán automáticamente después de iniciar sesión correctamente',
    line: 'Otras opciones de inicio de sesión',
  },
  button: {
    submit: 'Iniciar sesión/Registrarse',
    getCode: 'Obtener código',
    emailRegister: 'Registrarse por correo electrónico',
    w3Login: 'Inicio de sesión de cuenta W3',
    employeeLogin: 'Inicio de sesión del empleado',
    passwordLogin: 'Contraseña de inicio de sesión',
    reSend: 'Reenviar',
    problem: 'Ayuda en línea',
    privacyPolicy: 'Política de Privacidad',
  },
  placeholder: {
    phoneNumber: 'Número de celular',
    verificationCode: 'Código de verificación enviado por SMS',
  },
  dialog: {
    imgCode: 'Ingrese los caracteres que se muestran en la imagen.',
    userAgreements: {
      header: 'Contrato de usuario y Declaración de privacidad',
      text1: 'Lea y acepte la {privacy} y el {agreement}.',
      text2:
        'Al acceder a las aplicaciones de Huawei en el extranjero, la información personal se transferirá a las filiales de Huawei en el extranjero para su procesamiento. Para obtener más información, consulte {privacy}',
    },
    crossBorder: {
      header: 'Solicitud de autorización',
      text: 'El servicio local que utiliza y el lugar de registro de su cuenta no están en la misma región.El acceso transfronterizo a la información de la cuenta requiere su autorización.',
    },
    multiAccounts: 'Seleccione una cuenta.',
    agreeButton: 'Aceptar y continuar',
    disagreeButton: 'No acepto',
    confirmButton: 'Confirmar',
    cancelButton: 'Cancelar',
    knowMe: 'Aceptar',
  },
  toast: {
    hasSend: 'Código de verificación enviado.',
    wait: 'Un momento, por favor',
  },
  tooltip: {
    Huawei: 'ID de HUAWEI',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'El código CAPTCHA es obligatorio.',
    'IDC-03-0002': 'El código CAPTCHA ha expirado.',
    'IDC-00-0004': 'Código CAPTCHA incorrecto.',

    // 表单输入为空
    'IDC-01-00024': 'Se requiere el código del país para verificar su número de celular.',
    phoneNumberEmpty: 'Ingrese el número de celular.',
    'IDC-03-00033': 'Introduzca el código de verificación enviado por SMS.',

    // 表单数据错误
    'IDC-02-00227': 'El número de móvil introducido no coincide con el país o región seleccionado',
    'IDC-02-00226': 'El código de país está prohibido',
    'IDC-02-00029': 'El código de verificación es incorrecto o ha caducado',
    'IDC-02-0013':
      'Error de inicio de sesión por SMS debido a un código de verificación incorrecto',
    'IDC-02-0020': 'Error en la verificación. Código de verificación incorrecto.',
    'IDC-02-00028': 'El número de móvil debe contener de 6 a 30 dígitos',
    'IDC-02-00012': 'Número de móvil incorrecto',

    // 错误操作锁定
    accountLock:
      'Número de celular o código de verificación incorrectos. {number} intentos restantes. | Número de celular o código de verificación incorrectos. {number} intentos restantes.',
    accountLocked:
      'Demasiados intentos fallidos. Vuelva a intentarlo dentro de {number} segundos. | Demasiados intentos fallidos. Vuelva a intentarlo dentro de {number} segundos.',
    operationRisk:
      'La operación actual tiene riesgos de seguridad. Inténtelo de nuevo en {number} segundos.',

    // 频繁操作
    'IDC-02-00038': 'Inténtelo de nuevo después de 60 segundos.',
    'IDC-02-00064':
      'Ha enviado códigos de verificación SMS con demasiada frecuencia. Inténtelo de nuevo en 24 horas.',
    'IDC-02-00211': 'La operación actual tiene riesgos de seguridad. Inténtelo de nuevo más tarde.',
    'IDC-02-00212':
      'Su número de teléfono móvil envía el código de verificación SMS con demasiada frecuencia. Intente cambiar su número de teléfono móvil o vuelva a intentarlo en 24 horas.',
    'IDC-02-00213':
      'Ha enviado códigos de verificación SMS con demasiada frecuencia. Inténtelo de nuevo en 24 horas.',
    'IDC-02-00215':
      'Su número de teléfono móvil envía un código de verificación SMS con demasiada frecuencia. Cambie su número de teléfono móvil, seleccione otro método de verificación o inténtelo de nuevo en 24 horas.',
    'IDC-02-00228':
      'Ha enviado un código de verificación SMS con demasiada frecuencia. Inténtelo de nuevo en una hora.',
    'IDC-02-00092':
      'La operación actual es demasiado frecuente. Vuelva a intentarlo dentro de 24 horas.',

    // 请求异常
    'IDC-10-00400': 'Solicitud de cliente anormal',
    'IDC-10-00500': 'Error interno del sistema ',
    'IDC-02-00264': 'Las solicitudes de acceso no autorizadas están prohibidas',
    'IDC-02-00063': 'Parámetro no válido',
    'IDC-03-0007': 'La operación actual tiene riesgos de seguridad y no se puede registrar.', // 机翻
    'IDC-03-00057': 'La operación actual tiene riesgos de seguridad.',

    // 页面过期
    'IDC-00-00017': 'La página ha expirado.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Volver',
  closeButton: 'Cerrar',

  // 滑块验证相关：
  resourceReqFailed: 'Error al solicitar recursos. Actualice la página y vuelva a intentarlo.',
  verifyFailedAndPlsRetry: 'Error en la verificación. Inténtelo de nuevo',
  serviceErrAndPlsRetry: 'Excepción de servicio. Vuelva a intentarlo.',
  learnMore: 'Conozca más',
  cookieBannerText: 'Este sitio web utiliza cookies para ofrecerle la mejor experiencia de usuario posible.',
};
